import PrizePool from '../prize-pool/prize-pool';
import styles from './single-match-golden-duel-pool.module.scss';
import { antonio } from '@/lib/fonts';
import clsx from 'clsx';
import { Icon } from '@/components/icons/svg-icons/svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCube, Pagination } from 'swiper/modules';
import { useGoldenDuelSetting, useGroups } from '@/hooks/query/golden-duel';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { goldenDuelModalService } from '@/services/golden-duel/golden-duel-modal.service';
import { useThrottleClick } from '@nf/utils-common/hooks';
import { useEffect, useState } from 'react';
import { CdnImg } from '@/features/cdn-img';
import { promotionService } from '@/services/promotion.service';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { useLocale } from 'next-intl';
interface SingleMatchGoldenDuelPoolProps {
	isVideoBar?: boolean;
	matchId: number;
	parentMatchId: number;
}

export const SingleMatchGoldenDuelPool = ({ isVideoBar = false, matchId, parentMatchId }: SingleMatchGoldenDuelPoolProps) => {
	const queryMatchId = parentMatchId > 0 ? parentMatchId : matchId;
	const { data: groupsData } = useGroups([], [queryMatchId]);
	const { convertAmountByCurrency } = useGoldenDuelSetting();
	const [amount, setAmount] = useState(0);
	const { user } = useAccountInfo();
	const t = useTranslations('General');
	const defaultCurrencyId = promotionService.getDefaultCurrencyId();
	const defaultCurrencyName = promotionService.getDefaultCurrencyName();
	const locale = useLocale();
	const isUseNewFont = !['th-TH', 'vi-VN'].includes(locale);
	useEffect(() => {
		const amountByCurrency = convertAmountByCurrency(groupsData?.Data?.[0]?.PoolAmount ?? 0, user?.CurrId ?? defaultCurrencyId);
		amountByCurrency && setAmount(amountByCurrency);
	}, [convertAmountByCurrency, groupsData?.Data]);

	const setKafka = () => {
		const kafkaData = {
			note: KafkaNote.GoldenDuel,
			type: 1,
			action: 11
		};
		setKafkaNormal(kafkaData);
	}

	const clickDetailIcon = useThrottleClick(() => {
		setKafka();
		goldenDuelModalService.displayGoldenDuelRulesModal(true);
	}, 300);

	if (isVideoBar) {
		return (
			<div className={styles.videoBarPoolContainer}>
				<div className={styles.videoPrizeContainer}>
					<CdnImg
						isGalaxyFolder={true}
						src={'/images/promotion/golden-duel/promo-nba-logo.png'}
					/>
					<Swiper
						direction="vertical"
						autoplay={{
							delay: 5000,
							disableOnInteraction: false,
						}}
						effect={'cube'}
						grabCursor={false}
						cubeEffect={{
							shadow: false,
							slideShadows: false,
						}}
						speed={1000}
						loop={true}
						pagination={false}
						modules={[Autoplay, EffectCube, Pagination]}
						className={styles.videoBarBannerSwiper}
					>
						<SwiperSlide className={styles.videoPrizeComingSoonSlide}>
							<div className={clsx(styles.videoPrizeComingSoon, isUseNewFont && antonio.className)}>
								<span>
									{t('lbl_IncomingPay')}
								</span>
							</div>
						</SwiperSlide>
						<SwiperSlide>
							<div className={styles.videoPrizeWrapper}>
								<div className={clsx(styles.currency, styles.videoPrizeCurrency, antonio.className)}>
									{user?.LicenseeSiteSetting.DisplayCurrencyName ?? defaultCurrencyName}
								</div>
								<PrizePool
									totalPrize={amount}
									containerClassName={clsx(styles.prizeAmount, antonio.className, styles.videoPrizeAmount, 'single-match-prize-amount')}
									charClassName={clsx(styles.prizeChar, styles.videoPrizeChar, 'single-match-prize-char')}
								/>
							</div>
						</SwiperSlide>
					</Swiper>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.goldenDuelPanel}>
			<div className={styles.poolContainer}>
				{
					<button className={styles.detailIcon} onClick={clickDetailIcon}>
						<Icon name="details" />
					</button>
				}
				<div className={styles.titleContainer}>
					<div className={styles.decoLeft}></div>
					<div className={clsx(styles.title, isUseNewFont && antonio.className)}>
						<CdnImg
							isGalaxyFolder={true}
							src={'/images/promotion/golden-duel/promo-nba-logo.png'}
						/>
						{t('lbl_EventPopupTitle')}
					</div>
					<div className={styles.decoRight}></div>
				</div>
				<div className={styles.prizeContainer}>
					<div className={styles.swiperContainer}>
						<Swiper
							direction="vertical"
							autoplay={{
								delay: 5000,
								disableOnInteraction: false,
							}}
							effect={'cube'}
							grabCursor={false}
							cubeEffect={{
								shadow: false,
								slideShadows: false,
							}}
							speed={1000}
							loop={true}
							pagination={false}
							modules={[Autoplay, EffectCube, Pagination]}
							className={styles.singleMatchBannerSwiper}
						>
							<SwiperSlide>
								<div className={styles.videoPrizeWrapper}>
									<div className={clsx(styles.currency, styles.videoPrizeCurrency, antonio.className)}>
										{user?.LicenseeSiteSetting.DisplayCurrencyName ?? defaultCurrencyName}
									</div>
									<PrizePool
										totalPrize={amount}
										containerClassName={clsx(styles.prizeAmount, antonio.className, styles.videoPrizeAmount, 'single-match-prize-amount')}
										charClassName={clsx(styles.prizeChar, styles.videoPrizeChar, 'single-match-prize-char')}
									/>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div className={clsx(styles.comingSoon, isUseNewFont && antonio.className)}> 
									<span>
										{t('lbl_IncomingPay')}
									</span>
								</div>
							</SwiperSlide>
						</Swiper>
					</div>
					<div className={styles.description}>
						{t('lbl_EventPopupDesc')}
					</div>
				</div>
			</div>
		</div>
	);
};